var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "max-width": "700",
      "width": "100%"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v("Contact")])], 1), _c('v-card-text', {
    staticClass: "card-text primary--text font-weight-bold"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-phone")]), _vm._v(" (631) 581-9200 ")], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-mail")]), _vm._v(" help@eipl.org ")], 1)], 1)], 1), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(_vm.contacts, function (contact) {
    return [_c('v-list-item', {
      key: contact.extension,
      staticClass: "px-0"
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "primary--text text-body-1 font-weight-bold"
    }, [_vm._v(_vm._s(contact.department))]), _c('v-list-item-subtitle', {
      staticClass: "text-body-2 font-weight-bold"
    }, [_vm._v(" " + _vm._s(contact !== null && contact !== void 0 && contact.supervisor ? ("Supervisor: " + (contact.supervisor)) : contact.contact))])], 1), _c('v-list-item-action', {
      staticClass: "primary--text"
    }, [_c('v-list-item-action-text', [_vm._v(" Ext: ")]), _vm._v(" " + _vm._s(contact.extension) + " ")], 1)], 1), contact.extension !== '121' ? _c('v-divider', {
      key: contact.extension + 'd'
    }) : _vm._e()];
  })], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }